import { render, staticRenderFns } from "./AnimationIssuesActionsCard.vue?vue&type=template&id=9f9bf06a&"
import script from "./AnimationIssuesActionsCard.vue?vue&type=script&lang=js&"
export * from "./AnimationIssuesActionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports